export default __webpack_public_path__ + "static/media/Core-Values-03.98421229.png";